/* eslint-disable no-param-reassign */
import React, { Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Select, Table, DatePicker, Checkbox,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import ProductFilterV2 from '@Components/Common/ProductFilterV2';
import SelectTax from '../../../../Admin/Common/SelectTax';
import TenantSelector from '../../../../Common/Selector/TenantSelector';
import './style.scss';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const RfqLines = ({
  data, loading, title, handleProductChangeValue, handleProductChange, formSubmitted, addNewRow, tenantDepartmentId, updateData, handleDelete, MONEY, isDDAtProductlevel, addNewLineQuesRow, deleteLineQuesRow, user, priceMasking
}) => {
  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const getColumns = () => {
    const columns = [
      {
        title: 'PRODUCT',
        fixed: 'left',
        width: '220px',
        render: (text, record) => (
          <div style={{ minWidth: '300px' }}>
            <ProductFilterV2
              record={record}
              productTypes={['STORABLE', 'SERVICE', 'BUNDLE', 'NON_STORABLE']}
              handleProductChangeValue={handleProductChangeValue}
              handleProductChange={handleProductChange}
              required
              showError={formSubmitted && !record.product_sku_name}
              isSalesProduct
              onClear={(key) => {
                const copyData = JSON.parse(JSON.stringify(data));
                const newData = copyData.map((item) => {
                  if (item.key === key) {
                    return {
                      key: uuidv4(),
                      asset1: '',
                      product_sku_name: '',
                      quantity: '',
                      quotation_price: '',
                      tax_id: '',
                      product_sku_id: null,
                      product_sku_info: null,
                    };
                  }
                  return {
                    ...item,
                  };
                });
                addNewRow();
                updateData(newData);
              }}
              excludedProducts={data?.map((item) => JSON.stringify(item?.tenant_product_id)) || []}
              tenantDepartmentId={tenantDepartmentId}
              showClear={false}
              filterReservedQuantity
            />
            {record?.productCategoryInfo?.category_path?.length > 0 && (
              <ProductCategoryLabel
                categoryPath={record?.productCategoryInfo?.category_path}
                categoryName={record?.productCategoryInfo?.category_path?.at(
                  -1
                )}
                containerStyle={{
                  width: "fit-content",
                }}
              />
            )}
            {record?.product_sku_id && (
              <Fragment>
                <div className="rfq-table__line-questions">
                  {record?.rfq_line_questions?.map((ques) => (
                    <div key={ques?.key}>
                      {/* <div>Questions?</div> */}
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          value={ques?.question}
                          onChange={(e) => {
                            const copyData = JSON.parse(
                              JSON.stringify(data),
                            );
                            for (let i = 0; i < copyData?.length; i++) {
                              if (copyData[i]?.key === ques?.parentKey) {
                                const lineQuestions = copyData[i]?.rfq_line_questions;
                                for (let j = 0; j < lineQuestions?.length; j++) {
                                  if (lineQuestions[j]?.key === ques?.key) {
                                    lineQuestions[j].question = e.target.value;
                                  }
                                }
                              }
                            }
                            updateData(copyData);
                          }}
                          className={`rfq-table__line-ques ${(formSubmitted && !ques?.question) ? 'line-ques-error' : ''}`}
                          placeholder="Add Question for this item.."
                          maxLength="512"
                        />
                        <div style={{ width: '88px', marginLeft: '5px' }}>
                          <Checkbox
                            checked={ques?.is_mandatory}
                            onChange={(e) => {
                              const copyData = JSON.parse(
                                JSON.stringify(data),
                              );
                              for (let i = 0; i < copyData?.length; i++) {
                                if (copyData[i]?.key === ques?.parentKey) {
                                  const lineQuestions = copyData[i]?.rfq_line_questions;
                                  for (let j = 0; j < lineQuestions?.length; j++) {
                                    if (lineQuestions[j]?.key === ques?.key) {
                                      lineQuestions[j].is_mandatory = e.target.checked;
                                    }
                                  }
                                }
                              }
                              updateData(copyData);
                            }}
                          />
                          <span
                            style={{
                              fontWeight: '400',
                              fontSize: '12px',
                              marginLeft: '5px',
                            }}
                          >
                            required
                          </span>
                        </div>
                        <div
                          className="rfq-form__line-ques-remove"
                          onClick={() => deleteLineQuesRow(ques?.parentKey, ques?.key)}
                        >
                          <FontAwesomeIcon
                            icon={faCircleXmark}
                            size="sm"
                            style={{ color: '#6f7276' }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="rfq-table__add-line-ques" onClick={() => addNewLineQuesRow(record?.key)}>
                  + Add Question
                </div>
                {/* <textarea
                  value={record.remark}
                  onChange={(e) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    copyData.map((item) => {
                      if (item.key === record.key) {
                        item.remark = e.target.value;
                      }
                      return data;
                    });
                    updateData(copyData);
                  }}
                  className="rfq-table__remarks"
                  placeholder="Add description of this item.."
                /> */}
              </Fragment>
            )}
          </div>
        ),
      },
      {
        title: 'QUANTITY',
        dataIndex: 'quantity',
        width: '100px',
        render: (text, record) => (
          <div style={{ minWidth: '110px' }}>
            <H3FormInput
              value={record.quantity}
              type="number"
              containerClassName={`orgInputContainer ${(formSubmitted && Number(record.quantity) <= 0) ? 'create-pr__input' : ''}`}
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              onChange={(e) => {
                const copyData = JSON.parse(JSON.stringify(data));
                copyData.map((item) => {
                  if (item.key === record.key) {
                    item.quantity = e.target.value;
                  }
                  return data;
                });
                updateData(copyData);
              }}
            />
          </div>
        ),
      },
      {
        title: 'UNIT',
        width: '110px',
        render: (text, record) => (
          <div style={{ width: '110px' }}>
            <div className="orgInputContainer">
              <PRZSelect
                filterOption={false}
                className=""
                value={record?.uom_id}
                onChange={(value) => {
                  const copyData = JSON.parse(JSON.stringify(data));
                  copyData.map((item) => {
                    if (item.key === record.key) {
                      item.uom_id = value;
                      item.uom_info = item?.uom_list?.find((rec) => rec?.uom_id === value);
                    }
                    return item;
                  });
                  updateData(copyData);
                }}
                disabled={!record?.uom_list || record?.product_type === 'BUNDLE'}
                placeholder=""
              >
                {
                    record?.uom_list?.map((uom) => (
                      <Option key={uom?.uom_id} value={uom?.uom_id}>{`${uom?.uqc?.toProperCase()} (${uom?.uom_name?.toProperCase()})`}</Option>
                    ))
                }
              </PRZSelect>
            </div>
          </div>
        ),
      },
      {
        title: 'TAX',
        width: '110px',
        render: (text, record) => (
          <div style={{ width: '110px' }}>
            <div className="orgInputContainer">
              <SelectTax
                onChange={(value) => {
                  const copyData = JSON.parse(JSON.stringify(data));
                  copyData.map((item) => {
                    if (item.key === record.key) {
                      item.tax_id = value?.tax_id;
                      item.tax_info = value;
                    }
                    return item;
                  });
                  updateData(copyData);
                }}
                errorOutline={formSubmitted && !record.tax_id}
                selectedGST={record.tax_id}
              />
            </div>
          </div>
        ),
      },
      {
        title: 'DELIVERY LOCATION',
        width: '150px',
        render: (text, record) => (
          <div style={{ width: '150px' }}>
            <TenantSelector
              selectedTenant={record?.delivery_tenant_id}
              onChange={(value) => {
                const copyData = JSON.parse(JSON.stringify(data));
                copyData.map((item) => {
                  if (item.key === record.key) {
                    // eslint-disable-next-line no-param-reassign
                    item.delivery_tenant_id = value;
                  }
                  return data;
                });
                updateData(copyData);
              }}
              showSearch
              noDropdownAlign
              placeholder="Select Delivery Location"
              inputClassName="orgInputContainer"
              hideTitle
              showError={formSubmitted && !record?.delivery_tenant_id}
            />
          </div>
        ),
      },
      {
        title: 'TARGET PRICE',
        width: '110px',
        render: (text, record) => (
          <div style={{ minWidth: '110px' }}>
            <H3FormInput
              value={record.quotation_price}
              type="number"
              // containerClassName={`orgInputContainer ${(formSubmitted && Number(record.quotation_price) <= 0) ? 'create-pr__input' : ''}`}
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              onChange={(e) => {
                const copyData = JSON.parse(JSON.stringify(data));
                copyData.map((item) => {
                  if (item.key === record.key) {
                    // eslint-disable-next-line no-param-reassign
                    item.quotation_price = e.target.value;
                  }
                  return data;
                });
                updateData(copyData);
              }}
              hideInput={isDataMaskingPolicyEnable && isHideCostPrice}
              popOverMessage={"You don't have access to view/edit target price"}
            />
          </div>
        ),
      },
      {
        title: '',
        width: '40px',
        fixed: 'right',
        render: (text, record) => (
          <Fragment>
            {data.length !== record.key && (
              <div className="rfq-table__delete-line-button" onClick={() => handleDelete(record.key)}>
                <CloseOutlined />
              </div>
            )}
          </Fragment>
        ),
      },
    ];
    if (isDDAtProductlevel) {
      columns.splice(5, 0,
        {
          title: 'DELIVERY DATE',
          width: '120px',
          render: (text, record) => (
            <div style={{ width: '120px' }}>
              <DatePicker
                value={dayjs(record?.delivery_date)}
                disabledDate={(current) => current && current < dayjs().startOf('day')}
                onChange={(value) => {
                  const copyData = JSON.parse(JSON.stringify(data));
                  copyData.map((item) => {
                    if (item.key === record.key) {
                      // eslint-disable-next-line no-param-reassign
                      item.delivery_date = value;
                    }
                    return data;
                  });
                  updateData(copyData);
                }}
                style={{
                  border: '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '4px',
                  height: '32px',
                  padding: '1px 10px',
                  width: '100%',
                  background: 'white',
                }}
              />
            </div>
          ),
        });
    }
    return columns;
  };

  return (
    <div className="rfq-lines__wrapper">
      <Table
        title={title}
        bordered
        loading={loading}
        showHeader
        size="small"
        columns={getColumns()}
        dataSource={data}
        pagination={false}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, OfferReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateCustomPurchaseOrderLoading: PurchaseOrderReducers.updateCustomPurchaseOrderLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getOfferByTenantSkuLoading: OfferReducers.getOfferByTenantSkuLoading,
  priceMasking: UserReducers.priceMasking,
});

/**
 *
 * @return {{}}
 */
const mapDispatchToProps = () => ({

});

RfqLines.propTypes = {
  loading: PropTypes.bool,
  handleProductChangeValue: PropTypes.func,
  handleProductChange: PropTypes.func,
  handleDelete: PropTypes.func,
  updateData: PropTypes.func,
  data: PropTypes.any,
  title: PropTypes.any,
  formSubmitted: PropTypes.bool,
  isLineWiseDiscount: PropTypes.bool,
  addNewRow: PropTypes.func,
  tenantDepartmentId: PropTypes.any,
  MONEY: PropTypes.any,
  pricesToApply: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RfqLines));
